
export function MentorSection() {
  return (
    <section className="relative py-12 sm:py-16 lg:py-20 xl:py-24 bg-white overflow-hidden">
      <div className="absolute top-10 right-0 w-32 h-32 sm:w-48 sm:h-48 lg:w-64 lg:h-64 bg-gradient-to-br from-emerald-400/20 to-cyan-400/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 left-0 w-40 h-40 sm:w-60 sm:h-60 lg:w-80 lg:h-80 bg-gradient-to-br from-emerald-500/10 to-cyan-500/10 rounded-full blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl">
              <img
                alt="Esaul Lorenzo"
                className="w-full h-auto object-cover"
                src="https://static.readdy.ai/image/45eab4418adfae5cd9f32d2f060296c0/2b71e9ac5881b1b0a3522106f65a8458.png"
              />
            </div>
            <div className="absolute -bottom-3 -right-3 sm:-bottom-4 sm:-right-4 lg:-bottom-6 lg:-right-6 bg-gradient-to-r from-emerald-500 to-cyan-500 text-white px-4 sm:px-5 lg:px-6 py-2 sm:py-3 lg:py-4 rounded-xl sm:rounded-2xl shadow-2xl transform rotate-3">
              <div className="text-xl sm:text-2xl lg:text-3xl font-bold">10+</div>
              <div className="text-xs sm:text-sm font-medium whitespace-nowrap">Años de Experiencia</div>
            </div>
          </div>

          <div className="space-y-4 sm:space-y-6 order-1 lg:order-2">
            <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full bg-gradient-to-r from-emerald-100 to-cyan-100 border border-emerald-200">
              <i className="ri-user-star-line text-emerald-600 text-lg sm:text-xl"></i>
              <span className="text-emerald-700 text-xs sm:text-sm font-semibold whitespace-nowrap">Tu Mentor</span>
            </div>

            <div className="space-y-3 sm:space-y-4">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-extrabold text-gray-900 leading-tight">
                Soy <span className="bg-gradient-to-r from-emerald-500 to-cyan-500 bg-clip-text text-transparent">Esaul</span>
              </h2>

              <div className="space-y-3 sm:space-y-4 text-sm sm:text-base lg:text-lg text-gray-700 leading-relaxed">
                <p>
                  Tengo <strong className="text-gray-900">10 años dedicado al comercio online</strong> y desde hace{' '}
                  <strong className="text-gray-900">más de 3 años me dedico a la venta de productos digitales</strong>.
                </p>
                <p>
                  He ayudado a <strong className="text-emerald-600">muchos emprendedores a generar ingresos</strong> y mi objetivo es ayudarte a{' '}
                  <strong className="text-emerald-600">vivir de este negocio</strong>.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-3 gap-3 sm:gap-4 pt-4 sm:pt-6">
              <div className="text-center p-3 sm:p-4 rounded-lg sm:rounded-xl bg-gradient-to-br from-emerald-50 to-cyan-50">
                <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900">10</div>
                <div className="text-[10px] sm:text-xs lg:text-sm text-gray-600 whitespace-nowrap">Años Online</div>
              </div>
              <div className="text-center p-3 sm:p-4 rounded-lg sm:rounded-xl bg-gradient-to-br from-emerald-50 to-cyan-50">
                <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900">3+</div>
                <div className="text-[10px] sm:text-xs lg:text-sm text-gray-600 whitespace-nowrap">Años Digitales</div>
              </div>
              <div className="text-center p-3 sm:p-4 rounded-lg sm:rounded-xl bg-gradient-to-br from-emerald-50 to-cyan-50">
                <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900">500+</div>
                <div className="text-[10px] sm:text-xs lg:text-sm text-gray-600 whitespace-nowrap">Estudiantes</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
